import Service from './Service';
/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class DividasEmAbertoService extends Service {
  async consultarDividasEmAberto (filter) {
    let dividasEmAberto = [];
    let result = await this.getDividasEmAbertoApi().consultarDividasEmAberto(filter);
    dividasEmAberto = result;
    return dividasEmAberto;
  }
  async consultarDividasEmAbertoAsync (filter) {    
    await this.getDividasEmAbertoApi().consultarDividasEmAbertoAsync(filter);
  }
  async consultarDividaPorCarteira (carteira) {
    let dividaEmAberto = [];
    let result = await this.getDividasEmAbertoApi().consultarDividaPorCarteira(carteira);
    dividaEmAberto = result;
    return dividaEmAberto;
  }
  async consultarDividasEmAbertoDataTable (filter) {
    let dividasEmAberto = [];
    let result = await this.getDividasEmAbertoApi().consultarDividasEmAberto(filter);
    result.map(res => {
      const { beneficiario, situacaoAtual, saldoAnteriorDivida, valorDividaMes, valorPagamentoMes, perdasPorFalecimento, perdasPorPequenoValor, dividaEmAberto } = res;
      dividasEmAberto.push(Object.values({ beneficiario, situacaoAtual, saldoAnteriorDivida, valorDividaMes, valorPagamentoMes, perdasPorFalecimento, perdasPorPequenoValor, dividaEmAberto }));
    });
    return dividasEmAberto;
  }
  async getSituacao (codServidor) {
    let dividasEmAberto = [];
    let result = await this.getDividasEmAbertoApi().getSituacao(codServidor);
    dividasEmAberto = result;
    return dividasEmAberto;
  }
  async carregar (filter) {
    await this.getDividasEmAbertoApi().carregar(filter);
  }
}

export default DividasEmAbertoService;
